import { Arbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/entities/Arbeitsbereich';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/entities/Mitarbeiter';

interface Station {
  von: Date;
  bis: Date;
  abschnittId: string;
}

export class ArbeitsbereichStation implements Station {
  constructor({
    von,
    bis,
    arbeitsbereich,
    bereichsleiter,
    abschnittId,
  }: {
    von: Date;
    bis: Date;
    arbeitsbereich: Arbeitsbereich;
    bereichsleiter: Mitarbeiter;
    abschnittId: string;
  }) {
    this.von = von;
    this.bis = bis;
    this.arbeitsbereich = arbeitsbereich;
    this.bereichsleiter = bereichsleiter;
    this.abschnittId = abschnittId;
  }

  abschnittId: string;
  von: Date;
  bis: Date;
  arbeitsbereich: Arbeitsbereich;
  bereichsleiter: Mitarbeiter;
}

export class AbwesenheitsStation implements Station {
  constructor({
    von,
    bis,
    titel,
    abschnittId,
  }: {
    von: Date;
    bis: Date;
    titel: string;
    abschnittId: string;
  }) {
    this.von = von;
    this.bis = bis;
    this.titel = titel;
    this.abschnittId = abschnittId;
  }

  von: Date;
  bis: Date;
  titel: string;
  abschnittId: string;
}
